import { useState } from 'react';

import { UnsubscribedViewLayout } from '../../../../layout/UnsubscribedViewLayout.js';
import { OnboardingModuleProps } from '../../types.js';

type Props = {
  onFinish: () => Promise<void>;
  SubscriptionModule: OnboardingModuleProps['SubscriptionModule'];
};

export function SubscriptionStep({ onFinish, SubscriptionModule }: Props) {
  const [title, setTitle] = useState('Select a plan');

  return (
    <UnsubscribedViewLayout title={title}>
      <SubscriptionModule
        mode="legacy-new-user-trial"
        onPlanSelect={() => setTitle('Complete checkout')}
        onFinish={onFinish}
      />
    </UnsubscribedViewLayout>
  );
}
